module.exports = __webpack_public_path__ + "static/media/avatars_other_9.5dc2c7ba.png";